"use client";
import React, { useState, useEffect } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { HiChatAlt2 } from "react-icons/hi";
import { IoClose } from "react-icons/io5";

function MainComponent() {
    const [showFullScreenTrigger, setShowFullScreenTrigger] = useState(false);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [showChatIcon, setShowChatIcon] = useState(false);

    useEffect(() => {
        const hasSeenTrigger = localStorage.getItem("hasSeenChatTrigger");
        const isMobile = window.innerWidth < 768;

        if (!hasSeenTrigger && !isMobile) { // Don't show on mobile
            const timer = setTimeout(() => {
                if (!isChatOpen && !showChatIcon) {
                    setShowFullScreenTrigger(true);
                }
            }, 5000); // Increased delay for better UX

            return () => clearTimeout(timer);
        }
    }, [isChatOpen, showChatIcon]);

    const handleTriggerClick = () => {
        setShowFullScreenTrigger(false);
        setIsChatOpen(true);
        setShowChatIcon(true);
        localStorage.setItem("hasSeenChatTrigger", "true");
    };



    const handleCloseTrigger = () => {
        setShowFullScreenTrigger(false);
        localStorage.setItem("hasSeenChatTrigger", "true");
    };

    return (
        <>
            {/* Full-screen Trigger */}
            {showFullScreenTrigger && (
                <div className="fixed inset-0 bg-black bg-opacity-90 z-[1000] flex items-end justify-end p-4 md:p-10 cursor-default">
                    {/* Close button */}
                    <button
                        onClick={handleCloseTrigger}
                        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
                        aria-label="Close preview"
                    >
                        <IoClose size={28} />
                    </button>

                    {/* Animated arrow with text */}
                    <div
                        className="relative group animate-fadeInUp"
                        onClick={handleTriggerClick}
                    >
                        <div className="text-right mb-8 mr-8">
                            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                                The solution of your support
                            </h3>
                            <p className="text-white/80 text-sm md:text-base max-w-[500px]">
                                See how Void can transform your digital presence through every platform
                            </p>
                        </div>

                        <div className="flex justify-end">
                            <div className="relative animate-bounce hover:animate-none transition-all duration-300 group-hover:scale-110">
                                <MdArrowForwardIos
                                    size={80}
                                    className="text-white rotate-45"
                                />

                            </div>
                        </div>
                    </div>
                </div>
            )}




        </>
    );
}

export default MainComponent;